export default "__VITE_PUBLIC_ASSET__56c70d97__"